import { CustomFlowbiteTheme, Tooltip } from "flowbite-react";
import { Button } from "./Button";
import type { ButtonVariant } from "./Button";
import type { FC } from "react";
import type { Placement } from "@floating-ui/core";

interface IDropdownItem {
  text: React.ReactNode;
  onClick: () => void;
}

interface DropdownButtonProps {
  items: IDropdownItem[];
  buttonText?: string;
  buttonPrependIcon?: React.ReactNode;
  buttonAppendIcon?: React.ReactNode;
  placement?: Placement;
  buttonSize?: string;
  buttonVariant?: ButtonVariant;
  className?: string;
  menuClassName?: string;
  disabled?: boolean;
}

export const DropdownButton: FC<DropdownButtonProps> = (
  props: DropdownButtonProps,
) => {
  return (
    <Tooltip
      theme={selectedTheme}
      placement={props.placement}
      style="light"
      content={
        <div
          className={`w-full divide-y divide-gray-100 px-1 dark:divide-gray-500 z-10 ${props.menuClassName || ""}`}
        >
          {props.items.map((x, index) => {
            return (
              <div
                key={index}
                className="fit cursor-pointer hover:text-brand dark:hover:text-lgb-blue-200"
                onClick={() => x.onClick()}
              >
                <div className="flex items-center space-x-4">
                  <div className="flex gap-2">{x.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      }
    >
      <Button
        size={props.buttonSize ?? "md"}
        className={`relative truncate sm:text-sm text-base ${props.buttonText ? "ml-0 sm:ml-4" : ""} ${props.className || ""}`}
        {...(props.buttonVariant
          ? { variant: props.buttonVariant }
          : { color: "light" })}
        type="submit"
        disabled={props.disabled}
      >
        {props.buttonPrependIcon && (
          <span className="min-w-[16px] min-h-[16px]">
            {props.buttonPrependIcon}
          </span>
        )}
        <span className="truncate max-w-[80px] sm:max-w-none">
          {props.buttonText}
        </span>
        {props.buttonAppendIcon && (
          <span className="min-w-[16px] min-h-[16px] sm:text-sm text-base">
            {props.buttonAppendIcon}
          </span>
        )}
      </Button>
    </Tooltip>
  );
};

const selectedTheme: CustomFlowbiteTheme["tooltip"] = {
  base: "absolute z-10 inline-block rounded-lg text-sm font-medium shadow-lg",
  arrow: {
    base: "hidden",
  },
  style: {
    light:
      "border border-gray-200 bg-white text-gray-900 dark:border-none dark:bg-gray-700 dark:text-white",
  },
};

export default DropdownButton;
